module.exports = __webpack_public_path__ + "img/currency-guide-1.ca00650b.png";